import React, {useState, Component, useCallback} from 'react'
import PropTypes from 'prop-types'
import {useForm} from 'react-hook-form'
import {GenericModal} from './use-generic-modal'
import NotifyFields from '../components/forms/notify-fields'
import {useCurrentCustomer} from '../hooks/use-current-customer'
import {Divider, Stack, Text} from '@chakra-ui/react'
import {FormattedMessage} from 'react-intl'

/**
 * A Modal that contains Product View
 */
export const NotifyModal = ({product, isOpen, onClose, onOpen, finalFocusRef}) => {
    const {data: customer} = useCurrentCustomer()
    const form = useForm({
        defaultValues: {
            firstName: customer.firstName,
            lastName: customer.lastName,
            email: customer.email,
            phone: customer.phoneHome
        }
    })

    if (!product) {
        return null
    }

    return (
        <GenericModal
            colorScheme="stokkeGray"
            header={
                <Text as="h1" textStyle="Regular 4XLarge" pt={2}>
                    <FormattedMessage
                        defaultMessage="Notify me when the {0} is available"
                        values={{0: product.name}}
                        id="notify.modal.title.text"
                    />
                </Text>
            }
            size="2xl"
            isOpen={isOpen}
            onClose={onClose}
            finalFocusRef={finalFocusRef}
            onOpen={onOpen}
            paddingTop={0}
            bodyStyles={{paddingY: 0}}
            contentStyles={{
                paddingTop: {base: 8, lg: 10},
                containerProps: {'data-testid': 'notify-me-modal'}
            }}
        >
            <Text as="h2" textStyle="Regular Medium" pt={6}>
                <FormattedMessage
                    defaultMessage="Provide your email address to receive a notification email. Your email address will only be used for this purpose."
                    id="notify.modal.title.description"
                />
            </Text>
            <Stack paddingTop={6}>
                <Divider colorScheme="stokkeGray" />
            </Stack>
            <NotifyFields form={form} product={product} onClose={onClose} />
        </GenericModal>
    )
}

NotifyModal.propTypes = {
    isOpen: PropTypes.bool,
    onClose: PropTypes.func,
    onOpen: PropTypes.func,
    finalFocusRef: PropTypes.oneOfType([
        PropTypes.func,
        PropTypes.shape({current: PropTypes.instanceOf(Component)})
    ]),
    product: PropTypes.object
}

export const useNotifyMeModal = () => {
    const [product, setProduct] = useState(null)

    return {
        product,
        isOpen: product ? true : false,
        onClose: useCallback(() => setProduct(null), []),
        onOpen: setProduct
    }
}
